import Star from "@material-ui/icons/Star";
import Layers from "@material-ui/icons/Layers";
import Domain from "@material-ui/icons/Domain";
import People from "@material-ui/icons/People";
import Schedule from "@material-ui/icons/Schedule";
import TimerOff from "@material-ui/icons/TimerOff";
import Bookmarks from "@material-ui/icons/Bookmarks";
import OilRig from "features/planner/components/OilRigIcon";
import AccountCircle from "@material-ui/icons/AccountCircle";

import { OPEN_IN, RouteContainer } from "altus-ui-components";

import routePaths from "app/routePaths";
import { APP_ROLES } from "app/app.constants";
import DashboardIcon from "app/components/Icons/DashboardIcon";
import PlannerContainer from "features/planner/PlannerContainer";
import OverviewContainer from "app/components/OverviewContainer";
import EmployeeContainer from "features/planner/employee/EmployeeContainer";
import DashboardContainer from "features/planner/report/dashboard/DashboardContainer";
import SettingsCrewContainer from "features/planner/settings/crew/SettingsCrewContainer";
import EmployeeStayContainer from "features/planner/employee/stay/EmployeeStayContainer";
import HelicopterIcon from "features/planner/report/helicopter/components/HelicopterIcon";
import SubContractorContainer from "features/planner/subcontractor/SubContractorContainer";
import POBReportContainer from "features/planner/report/people-on-board/POBReportContainer";
import SettingsFieldsContainer from "features/planner/settings/fields/SettingsFieldsContainer";
import SettingsCompanyContainer from "features/planner/settings/company/SettingsCompanyContainer";
import SettingsMarkersContainer from "features/planner/settings/markers/SettingsMarkersContainer";
import EmployeeCalendarContainer from "features/planner/employee/calendar/EmployeeCalendarContainer";
import SettingsUserAccessContainer from "features/planner/settings/access/SettingsUserAccessContainer";
import EmployeeNextOfKinContainer from "features/planner/employee/nextofkin/EmployeeNextOfKinContainer";
import EmployeeGeneralInfoContainer from "features/planner/employee/general/EmployeeGeneralInfoContainer";
import SettingsFacilitiesContainer from "features/planner/settings/facilities/SettingsFacilitiesContainer";
import WorkScheduleReportContainer from "features/planner/report/workSchedule/WorkScheduleReportContainer";
import EmployeeTravelHistoryContainer from "features/planner/employee/travel/EmployeeTravelHistoryContainer";
import EmployeeWorkScheduleContainer from "features/planner/employee/schedule/EmployeeWorkScheduleContainer";
import SubContractorCompanyContainer from "features/planner/subcontractor/company/SubContractorCompanyContainer";
import SubContractorDetailsContainer from "features/planner/subcontractor/details/SubContractorDetailsContainer";
import SettingsLocationGroupsContainer from "features/planner/settings/locations/SettingsLocationGroupsContainer";
import HelicopterBookingReportContainer from "features/planner/report/helicopter/HelicopterBookingReportContainer";
import SettingsEmployeeGroupsContainer from "features/planner/settings/employeeGroups/SettingsEmployeeGroupsContainer";
import SettingsPlanningGroupsContainer from "features/planner/settings/planningGroups/SettingsPlanningGroupsContainer";
import SettingsQualificationsContainer from "features/planner/settings/qualifications/SettingsQualificationsContainer";
import SettingsSubContractorsContainer from "features/planner/settings/subcontractors/SettingsSubContractorsContainer";
import ScheduleOverridesReportContainer from "features/planner/report/schedule-overrides/ScheduleOverridesReportContainer";
import SettingsMobileFacilitiesContainer from "features/planner/settings/mobileFacilities/SettingsMobileFacilitiesContainer";
import EmployeeCoursesContainer from "features/planner/employee/courses/EmployeeCoursesContainer";

export const settingsRoutes = [
  {
    path: "/settings",
    breadcrumb: "Settings",
    component: RouteContainer,
    accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
    routes: [
      {
        exact: true,
        hidden: true,
        breadcrumb: "Overview",
        path: "/settings",
        component: OverviewContainer,
      },
      {
        path: "/settings/company",
        breadcrumb: "Companies",
        Icon: Domain,
        component: SettingsCompanyContainer,
        crudAccessLevel: {
          create: [APP_ROLES.ADMIN],
          edit: [APP_ROLES.ADMIN],
          delete: [APP_ROLES.ADMIN],
        },
      },
      {
        path: "/settings/crew",
        breadcrumb: "Crews",
        Icon: People,
        component: SettingsCrewContainer,
        crudAccessLevel: {
          create: [APP_ROLES.ADMIN],
          edit: [APP_ROLES.ADMIN],
          delete: [APP_ROLES.ADMIN],
        },
      },
      {
        path: "/settings/employee-group",
        breadcrumb: "Employee Groups",
        Icon: People,
        component: SettingsEmployeeGroupsContainer,
        crudAccessLevel: {
          create: [APP_ROLES.ADMIN],
          edit: [APP_ROLES.ADMIN],
          delete: [APP_ROLES.ADMIN],
        },
      },
      {
        path: "/settings/facility",
        breadcrumb: "Facilities",
        Icon: OilRig,
        component: SettingsFacilitiesContainer,
        crudAccessLevel: {
          create: [APP_ROLES.ADMIN],
          edit: [APP_ROLES.ADMIN],
          delete: [APP_ROLES.ADMIN],
        },
      },
      {
        path: "/settings/field",
        breadcrumb: "Fields",
        Icon: Layers,
        component: SettingsFieldsContainer,
        crudAccessLevel: {
          create: [APP_ROLES.ADMIN],
          edit: [APP_ROLES.ADMIN],
          delete: [APP_ROLES.ADMIN],
        },
      },
      {
        path: "/settings/location-group",
        breadcrumb: "Location Groups",
        Icon: OilRig,
        component: SettingsLocationGroupsContainer,
        crudAccessLevel: {
          create: [APP_ROLES.ADMIN],
          edit: [APP_ROLES.ADMIN],
          delete: [APP_ROLES.ADMIN],
        },
      },
      {
        path: "/settings/marker",
        breadcrumb: "Markers",
        Icon: Bookmarks,
        component: SettingsMarkersContainer,
        crudAccessLevel: {
          create: [APP_ROLES.ADMIN],
          edit: [APP_ROLES.ADMIN],
          delete: [APP_ROLES.ADMIN],
        },
      },
      {
        path: "/settings/mobile-facility",
        breadcrumb: "Mobile Facilities",
        Icon: OilRig,
        component: SettingsMobileFacilitiesContainer,
        crudAccessLevel: {
          create: [APP_ROLES.ADMIN],
          edit: [APP_ROLES.ADMIN],
          delete: [APP_ROLES.ADMIN],
        },
      },
      {
        path: "/settings/planning-group",
        breadcrumb: "Planning Groups",
        Icon: People,
        component: SettingsPlanningGroupsContainer,
        crudAccessLevel: {
          create: [APP_ROLES.ADMIN],
          edit: [APP_ROLES.ADMIN],
          delete: [APP_ROLES.ADMIN],
        },
      },
      {
        path: "/settings/qualitification",
        breadcrumb: "Qualifications",
        Icon: Star,
        component: SettingsQualificationsContainer,
        crudAccessLevel: {
          create: [APP_ROLES.ADMIN],
          edit: [APP_ROLES.ADMIN],
          delete: [APP_ROLES.ADMIN],
        },
      },
      {
        path: "/settings/user-access",
        breadcrumb: "User Access",
        Icon: AccountCircle,
        component: SettingsUserAccessContainer,
        accessLevel: [APP_ROLES.ADMIN],
      },
      {
        path: "/settings/sub-contractor",
        breadcrumb: "Sub Contractors",
        Icon: People,
        component: SettingsSubContractorsContainer,
      },
    ],
  },
];

const reportsRoutes = [
  {
    path: "/reports",
    breadcrumb: "Reports",
    component: RouteContainer,
    accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER, APP_ROLES.VIEWER],
    routes: [
      {
        exact: true,
        hidden: true,
        path: "/reports",
        component: OverviewContainer,
      },
      {
        path: "/reports/helicopter-booking",
        breadcrumb: "Helicopter Booking",
        Icon: HelicopterIcon,
        component: RouteContainer,
        openIn: OPEN_IN.WINDOW,
        accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
        routes: [
          {
            Icon: HelicopterIcon,
            path: "/reports/helicopter-booking/:groupId?",
            breadcrumb: "Helicopter Booking",
            component: HelicopterBookingReportContainer,
          },
        ],
      },
      {
        path: "/reports/people-on-board",
        breadcrumb: "People On Board",
        Icon: People,
        component: POBReportContainer,
        openIn: OPEN_IN.WINDOW,
        accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
      },
      {
        path: "/reports/work-schedule",
        breadcrumb: "Work Schedule",
        Icon: Schedule,
        component: WorkScheduleReportContainer,
        openIn: OPEN_IN.TAB,
        accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
      },
      {
        path: "/reports/schedule-events",
        breadcrumb: "Current Events",
        Icon: TimerOff,
        component: ScheduleOverridesReportContainer,
        openIn: OPEN_IN.WINDOW,
        accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
      },
      {
        path: "/reports/dashboard",
        breadcrumb: "Dashboard",
        Icon: DashboardIcon,
        component: DashboardContainer,
        openIn: OPEN_IN.WINDOW,
      },
    ],
  },
];

export const employeeRoutes = [
  {
    path: "/employee/:employeeCardId",
    component: EmployeeContainer,
    accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
    routes: [
      {
        exact: true,
        path: "/employee/:employeeCardId",
        breadcrumb: "General",
        component: EmployeeGeneralInfoContainer,
      },
      {
        path: "/employee/:employeeCardId/next-of-kin",
        breadcrumb: "Next of kin",
        component: EmployeeNextOfKinContainer,
      },
      {
        path: "/employee/:employeeCardId/stay",
        breadcrumb: "Stay",
        component: EmployeeStayContainer,
      },
      {
        path: "/employee/:employeeCardId/travel-history",
        breadcrumb: "Travel History",
        component: EmployeeTravelHistoryContainer,
      },
      {
        path: "/employee/:employeeCardId/course",
        breadcrumb: "Courses",
        component: EmployeeCoursesContainer,
      },
      {
        path: "/employee/:employeeCardId/work-schedule",
        breadcrumb: "Work Schedule",
        component: EmployeeWorkScheduleContainer,
      },
      {
        path: "/employee/:employeeCardId/calendar",
        breadcrumb: "Calendar",
        component: EmployeeCalendarContainer,
      },
    ],
  },
];

export const subcontractorRoutes = [
  {
    path: "/sub-contractor/:employeeCardId",
    component: SubContractorContainer,
    accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER],
    routes: [
      {
        exact: true,
        path: "/sub-contractor/:employeeCardId",
        breadcrumb: "General",
        component: SubContractorDetailsContainer,
      },
      {
        path: "/sub-contractor/:employeeCardId/company",
        breadcrumb: "Company",
        component: SubContractorCompanyContainer,
      },
      {
        path: "/sub-contractor/:employeeCardId/stay",
        breadcrumb: "Stay",
        component: EmployeeStayContainer,
      },
      {
        path: "/sub-contractor/:employeeCardId/travel-history",
        breadcrumb: "Travel History",
        component: EmployeeTravelHistoryContainer,
      },
      {
        path: "/sub-contractor/:employeeCardId/work-schedule",
        breadcrumb: "Work Schedule",
        component: EmployeeWorkScheduleContainer,
      },
      {
        path: "/sub-contractor/:employeeCardId/calendar",
        breadcrumb: "Calendar",
        component: EmployeeCalendarContainer,
      },
    ],
  },
];

const routes = [
  {
    path: routePaths.root,
    component: RouteContainer,
    accessLevel: [APP_ROLES.ADMIN, APP_ROLES.PLANNER, APP_ROLES.VIEWER],
    routes: [
      {
        exact: true,
        component: PlannerContainer,
        path: [routePaths.root, routePaths.view],
      },
      ...settingsRoutes,
      ...reportsRoutes,
      ...employeeRoutes,
      ...subcontractorRoutes,
    ],
  },
];

export default routes;
